'use client';

import { c as _c } from "react/compiler-runtime";
import 'rc-slider/assets/index.css';
import { useParams, useSearchParams } from 'next/navigation';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import ListingFilterNew from '@/features/listing/components/listings-filters/listing-filter-new/listing-filter-new';
import ListingFilterRange from '@/features/listing/components/listings-filters/listing-filter-range/listing-filter-range';
import ListingFilterSection from '@/features/listing/components/listings-filters/listing-filter-section/listing-filter-section';
import ListingFilterToggle from '@/features/listing/components/listings-filters/listing-filter-toggle/listing-filter-toggle';
import ListingRadiusFilter from '@/features/listing/components/listings-filters/listing-radius-filter/listing-radius-filter';
import { LISTING_URL_PART_VARIANTS } from '@/features/listing/constants/listing-constants';
import { APARTMENT_AMENITIES_FILTER, BATHROOMS_FILTER, BEDROOMS_FILTER, HOUSEHOLD_SEX_FILTER, LISTINGS_AGE_FILTER, PET_OWN_FILTER, PET_PREFERRED_FILTER, SEX_FILTER, ZODIAC_FILTER } from '@/features/listing/constants/listings-filters-constants';
import { FiltersNames, type ListingsFilterName, type ListingsRangeFilter, PaginationNames } from '@/features/listing/types/listing-filters-types';
import { ListingUrlSchema } from '@/features/listing/types/listing-types';
import { useRouter } from '@/i18n/routing';
interface ListingDetailedFiltersProps {
  onFilterDisplayChange: (filterName: ListingsFilterName | null) => void;
  setFilterLink: (link: {
    pathname: string;
    searchParams: URLSearchParams;
  }) => void;
  filterLink: {
    pathname: string;
    searchParams: URLSearchParams;
  };
}
export default function ListingDetailedFilters(props) {
  const $ = _c(31);
  const {
    filterLink,
    onFilterDisplayChange,
    setFilterLink
  } = props;
  const params = useParams();
  const currentSearchParams = useSearchParams();
  const router = useRouter();
  const [isPopoverOpen, setPopoverOpen] = useState(false);
  const translationsFilters = useTranslations("listing.filters");
  let t0;
  if ($[0] !== currentSearchParams || $[1] !== filterLink || $[2] !== isPopoverOpen || $[3] !== onFilterDisplayChange || $[4] !== params.listingType || $[5] !== router || $[6] !== setFilterLink || $[7] !== translationsFilters) {
    const filters = {
      haveapartment: [BEDROOMS_FILTER, BATHROOMS_FILTER, APARTMENT_AMENITIES_FILTER],
      haveshare: [LISTINGS_AGE_FILTER, HOUSEHOLD_SEX_FILTER, ZODIAC_FILTER, PET_PREFERRED_FILTER],
      needapartment: [BEDROOMS_FILTER, APARTMENT_AMENITIES_FILTER],
      needroom: [LISTINGS_AGE_FILTER, SEX_FILTER, ZODIAC_FILTER, PET_OWN_FILTER]
    };
    const validateListingType = ListingUrlSchema.safeParse(params.listingType);
    const paramsListingType = validateListingType.data ?? "rooms-for-rent";
    const currentListingType = LISTING_URL_PART_VARIANTS[paramsListingType];
    const currentFilters = filters[currentListingType];
    let activeFiltersCount = 0;
    currentFilters.forEach(filter => {
      if (filter.filterType === "range") {
        if (currentSearchParams.has(filter.options.max.name) || currentSearchParams.has(filter.options.min.name)) {
          activeFiltersCount = activeFiltersCount + 1;
          activeFiltersCount;
        }
      } else {
        if (currentSearchParams.has(filter.name)) {
          activeFiltersCount = activeFiltersCount + 1;
          activeFiltersCount;
        }
      }
    });
    if (currentSearchParams.has(FiltersNames.GeoRadiusScale)) {
      activeFiltersCount = activeFiltersCount + 1;
      activeFiltersCount;
    }
    const handleFiltersClear = () => {
      const {
        pathname,
        searchParams
      } = filterLink;
      currentFilters.forEach(filter_0 => {
        if (filter_0.filterType === "range") {
          searchParams.delete(filter_0.options.min.name);
          searchParams.delete(filter_0.options.max.name);
        } else {
          searchParams.delete(filter_0.name);
        }
      });
      searchParams.delete("search_params.geo.radius_scale");
      setFilterLink({
        pathname,
        searchParams
      });
    };
    let t1;
    if ($[9] !== setFilterLink) {
      t1 = updatedFilterLink => {
        if (updatedFilterLink.searchParams.has(PaginationNames.PageNumber)) {
          updatedFilterLink.searchParams.delete(PaginationNames.PageNumber);
        }
        setFilterLink(updatedFilterLink);
      };
      $[9] = setFilterLink;
      $[10] = t1;
    } else {
      t1 = $[10];
    }
    const handleChangeFilterLink = t1;
    let t2;
    if ($[11] !== filterLink.pathname || $[12] !== filterLink.searchParams || $[13] !== router) {
      t2 = () => {
        router.push(`${filterLink.pathname}?${filterLink.searchParams.toString()}`);
      };
      $[11] = filterLink.pathname;
      $[12] = filterLink.searchParams;
      $[13] = router;
      $[14] = t2;
    } else {
      t2 = $[14];
    }
    const handleApplyClick = t2;
    const t3 = activeFiltersCount;
    let t4;
    if ($[15] !== translationsFilters) {
      t4 = translationsFilters("common.button");
      $[15] = translationsFilters;
      $[16] = t4;
    } else {
      t4 = $[16];
    }
    let t5;
    if ($[17] !== translationsFilters) {
      t5 = translationsFilters("common.dropdown-title");
      $[17] = translationsFilters;
      $[18] = t5;
    } else {
      t5 = $[18];
    }
    let t6;
    if ($[19] !== translationsFilters) {
      t6 = translationsFilters("filter-titles.radius");
      $[19] = translationsFilters;
      $[20] = t6;
    } else {
      t6 = $[20];
    }
    let t7;
    if ($[21] !== filterLink || $[22] !== handleChangeFilterLink) {
      t7 = <ListingRadiusFilter filterLink={filterLink} setFilterLink={handleChangeFilterLink} />;
      $[21] = filterLink;
      $[22] = handleChangeFilterLink;
      $[23] = t7;
    } else {
      t7 = $[23];
    }
    let t8;
    if ($[24] !== t6 || $[25] !== t7) {
      t8 = <ListingFilterSection title={t6}>{t7}</ListingFilterSection>;
      $[24] = t6;
      $[25] = t7;
      $[26] = t8;
    } else {
      t8 = $[26];
    }
    let t9;
    if ($[27] !== filterLink || $[28] !== handleChangeFilterLink || $[29] !== translationsFilters) {
      t9 = filter_1 => {
        if (filter_1.filterType === "checkbox" || filter_1.filterType === "radio") {
          return <ListingFilterSection key={filter_1.filterTitle} title={translationsFilters(`filter-titles.${filter_1.filterTitle as 'age'}`)}><ListingFilterToggle filterLink={filterLink} filter={filter_1} columns={filter_1.columns} setFilterLink={handleChangeFilterLink} /></ListingFilterSection>;
        }
        if (filter_1.filterType === "range") {
          const cloneFilter = JSON.stringify(filter_1);
          const updatedFilter = JSON.parse(cloneFilter) as ListingsRangeFilter;
          updatedFilter.options.min.value = Number(filterLink.searchParams.get(filter_1.options.min.name)) || filter_1.options.min.defaultValue;
          updatedFilter.options.max.value = Number(filterLink.searchParams.get(filter_1.options.max.name)) || filter_1.options.max.defaultValue;
          return <ListingFilterSection key={filter_1.filterTitle} title={translationsFilters(`filter-titles.${filter_1.filterTitle as 'age'}`)}><ListingFilterRange filterLink={filterLink} filter={updatedFilter} setFilterLink={handleChangeFilterLink} /></ListingFilterSection>;
        }
        return null;
      };
      $[27] = filterLink;
      $[28] = handleChangeFilterLink;
      $[29] = translationsFilters;
      $[30] = t9;
    } else {
      t9 = $[30];
    }
    t0 = <ListingFilterNew activeFiltersCount={t3} buttonText={t4} dialogTitle={t5} onFilterDisplayChange={onFilterDisplayChange} listingFilterName="listingsDetailed" isPopoverOpen={isPopoverOpen} setPopoverOpen={setPopoverOpen} onClear={handleFiltersClear} onApplyClick={handleApplyClick}>{t8}{currentFilters.map(t9)}</ListingFilterNew>;
    $[0] = currentSearchParams;
    $[1] = filterLink;
    $[2] = isPopoverOpen;
    $[3] = onFilterDisplayChange;
    $[4] = params.listingType;
    $[5] = router;
    $[6] = setFilterLink;
    $[7] = translationsFilters;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  return t0;
}